import React, { PropsWithChildren } from 'react';
import { layoutContentWrapperStyle } from './layout-content.styles.css';

type LayoutContentProps = {
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

export const LayoutContent: React.FC<PropsWithChildren<LayoutContentProps>> = ({
    children,
    onClick
}) => (
    <div className={layoutContentWrapperStyle} onClick={onClick}>
        {children}
    </div>
);
